import { render, staticRenderFns } from "./resiveHome.vue?vue&type=template&id=54b23031&scoped=true&"
var script = {}
import style0 from "./resiveHome.vue?vue&type=style&index=0&id=54b23031&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b23031",
  null
  
)

export default component.exports